import { render, staticRenderFns } from "./PanelThree.vue?vue&type=template&id=4f85fa3a&scoped=true&"
import script from "./PanelThree.vue?vue&type=script&lang=js&"
export * from "./PanelThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85fa3a",
  null
  
)

export default component.exports